import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    divReceipt: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '414px' : '980px'),
    },
    card: {
      width: '744px',
      height: '384px',
      borderRadius: '25px',
      padding: '20px 40px',
      background: '#FFFFFF',
      display: ({ isMobile }: StyleProps) => (isMobile ? 'table-cell' : 'flex'),
      justifyContent: 'space-between',
      border: '1px solid #2D6DF6',
    },
    labelSorry: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '48px',
      color: '#2D6DF6',
    },
    labelDescrip: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000000',
      marginTop: '10px',
    },
    link: {
      color: '#2D6DF6',
    },
    labelSURA: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '16px',
      color: '#2D6DF6',
      marginTop: '60px',
    },
    img: {
      marginTop: ({ isMobile }: StyleProps) => (isMobile ? '20px' : 0),
    },
  }),
);

export default useStyles;
